const autoClearTimer = {
  methods: {
    setAutoClearTimer(func, duration, isInterval = false) {
      let timer = isInterval ? setInterval(func, duration) : setTimeout(func, duration);
      this.$once('hook:beforeDestroy', () => {
        if (isInterval) {
          clearInterval(timer);
        } else {
          clearTimeout(timer);
        }
        timer = null;
      });
    },
  },
};

export default autoClearTimer;
